const blockAttributes = {
	title: {
		type: "string",
		default: "Your Payment has been recieved",
	},
	alignment: {
		type: "string",
		default: "center",
	},
	link: {
		type: "string",
	},
	text_color: {
		type: "string",
		default: "#000000",
	},
	textsize: {
		type: "string",
		default: "17px",
	},
};

export default blockAttributes;
